import { CalendarPreferences } from "@/features/calendar/components/Preferences/CalendarPreferences";
import { Preferences } from "@/core/types";

import { useAdminProfile } from "../api/queries/useAdminProfile";
import { useUpdateAdminProfile } from "../api/mutations/useUpdateAdminProfile";

export function AdminCalendarPreferencesCard() {
  const { data: profileData } = useAdminProfile();
  const { mutateAsync } = useUpdateAdminProfile({
    meta: { component: "AdminCalendarPreferencesCard" },
  });

  const handleUpdate = (newPreferences: Preferences) =>
    mutateAsync({ preferences: newPreferences });

  return <CalendarPreferences onUpdate={handleUpdate} preferences={profileData?.preferences} />;
}
